import styled from "styled-components";

export const UnreadWrapper = styled.section`
  display: inline;
  font-weight: bold;
  padding: 4px 0px;
  color: red;
  text-align: center;
  white-space: nowrap;
`;